import { render, staticRenderFns } from "./rule-table.vue?vue&type=template&id=00845c14&scoped=true"
import script from "./rule-table.vue?vue&type=script&lang=js"
export * from "./rule-table.vue?vue&type=script&lang=js"
import style0 from "./rule-table.vue?vue&type=style&index=0&id=00845c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00845c14",
  null
  
)

export default component.exports